export default __webpack_public_path__ + "static/media/dragon_animated.631f5480.svg";